if (!customElements.get('quick-add-bulk')) {
    customElements.define('quick-add-bulk', class QuickAddBulk extends BulkAdd {
        constructor() {
            super();
            this.quantity = this.querySelector('quantity-input');
            this.lastActiveInputId = null;

            const debouncedOnChange = debounce((event) => {
                if (parseInt(event.target.value) === 0) {
                    this.startQueue(event.target.dataset.index, parseInt(event.target.value));
                } else {
                    this.validateQuantity(event);
                }
            }, ON_CHANGE_DEBOUNCE_TIMER);

            this.addEventListener('change', debouncedOnChange.bind(this));
            this.listenForActiveInput();
            this.listenForKeydown();

            const pageParams = new URLSearchParams(window.location.search);
            window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
        }

        connectedCallback() {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                if (
                    event.source === 'quick-add' ||
                    (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
                    (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
                ) {
                    return;
                }
                this.onCartUpdate().then(() => {
                    this.listenForActiveInput();
                    this.listenForKeydown();
                });
            });
        }

        disconnectedCallback() {
            if (this.cartUpdateUnsubscriber) {
                this.cartUpdateUnsubscriber();
            }
        }

        getInput() {
            return this.querySelector('quantity-input input');
        }

        selectProgressBar() {
            return this.querySelector('.progress-bar-container');
        }

        listenForActiveInput() {
            const input = this.getInput();
            if (input) {
                input.addEventListener('focusin', (event) => event.target.select());
            }
            this.isEnterPressed = false;
        }

        listenForKeydown() {
            const input = this.getInput();
            if (input) {
                input.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        input.blur();
                        this.isEnterPressed = true;
                    }
                });
            }
        }

        cleanErrorMessageOnType(event) {
            event.target.addEventListener(
                'keypress',
                () => {
                    event.target.setCustomValidity('');
                },
                { once: true }
            );
        }

        async onCartUpdate() {
            try {
                const collection = this.closest('.collection');
                if (!collection) {
                    console.error("Collection element not found.");
                    return;
                }

                const response = await fetch(`${this.getSectionsUrl()}?section_id=${collection.dataset.id}`);
                const responseText = await response.text();

                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const sourceQty = html.querySelector(`#quick-add-bulk-${this.dataset.id}-${collection.dataset.id}`);

                if (sourceQty) {
                    this.innerHTML = sourceQty.innerHTML;
                }
            } catch (error) {
                console.error("Error updating cart:", error);
            }
        }

        updateMultipleQty(items) {
            this.selectProgressBar()?.classList.remove('hidden');

            const ids = Object.keys(items);
            const body = JSON.stringify({
                updates: items,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: this.getSectionsUrl(),
            });

            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
                .then((response) => response.text())
                .then((state) => {
                    const parsedState = JSON.parse(state);
                    this.renderSections(parsedState, ids);
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
                })
                .catch((error) => console.error("Cart update error:", error))
                .finally(() => {
                    this.selectProgressBar()?.classList.add('hidden');
                    this.requestStarted = false;
                });
        }

        getSectionsToRender() {
            const collection = this.closest('.collection-quick-add-bulk');
            if (!collection) {
                console.error("Collection element not found.");
                return [];
            }

            return [
                {
                    id: `quick-add-bulk-${this.dataset.id}-${collection.dataset.id}`,
                    section: collection.dataset.id,
                    selector: `#quick-add-bulk-${this.dataset.id}-${collection.dataset.id}`,
                },
                {
                    id: 'cart-icon-bubble',
                    section: 'cart-icon-bubble',
                    selector: '.shopify-section',
                },
                {
                    id: 'CartDrawer',
                    selector: '#CartDrawer',
                    section: 'cart-drawer',
                }
            ];
        }

        renderSections(parsedState, ids) {
            const intersection = this.queue?.filter((element) => ids.includes(element.id)) || [];
            if (intersection.length !== 0) return;

            this.getSectionsToRender().forEach((section) => {
                const sectionElement = document.getElementById(section.id);
                if (!sectionElement) {
                    console.warn(`Section ${section.id} not found.`);
                    return;
                }

                if (sectionElement.parentElement?.classList.contains('drawer')) {
                    sectionElement.parentElement.classList.toggle('is-empty', parsedState.items.length === 0);
                    setTimeout(() => {
                        document.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.cart.close.bind(this.cart));
                    });
                }

                const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
                if (elementToReplace) {
                    elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }
            });

            if (this.isEnterPressed) {
                this.querySelector(`#Quantity-${this.lastActiveInputId}`)?.select();
            }

            this.listenForActiveInput();
            this.listenForKeydown();
        }
    });
}
